import moment from 'moment';

export const I18N_VEE_VALIDATE_CONSTANT = {
    'pt-BR': {
        messages: {
            // padrao
            alpha: () => 'Apenas letras são permitidas',
            alpha_spaces: () => 'Apenas letras e espaços vazios são permitidos',
            email: () => 'Coloque um e-mail válido por favor.',
            min: (info, min) => `Mínimo ${min} caracteres`,
            max: (info, max) => `Mínimo ${max} caracteres`,
            min_value: (info, min_value) => `Mínimo ${min_value}`,
            max_value: (info, max_value) => `Máximo ${max_value}`,
            regex: () => 'Valor inválido',
            required: () => 'É necessário colocar um e-mail.',
            confirmed: () => 'As senhas não coincidem',
            numeric: () => 'Número inválido',

            cpf: () => 'CPF Inválido',
            birthday_elder: () => 'Data Inválida',
            time: () => 'Horário inválido',
            before: (field, before) => `A data deve ser inferior a ${moment(before, 'YYYY-MM-DD').format('DD/MM/YYYY')}`,
            after: (field, after) => `A data deve ser superior a ${moment(after, 'YYYY-MM-DD').format('DD/MM/YYYY')}`
        }
    }
};
